// K4 Hatchback hero images
import k4HatchbackHeroDesktop from "../../../assets/img/models/k4-hatchback/hero/k4-hatchback-desktop.webp";
import k4HatchbackHeroMobile from "../../../assets/img/models/k4-hatchback/hero/k4-hatchback-mobile.webp";
// K4 Hatchback color images
import k4HatchbackColorFieryRed from "../../../assets/img/models/k4-hatchback/colors/k4-hatchback-color-fiery-red.webp";
import k4HatchbackColorSparklingYellow from "../../../assets/img/models/k4-hatchback/colors/k4-hatchback-color-sparkling-yellow.webp";
import k4HatchbackColorMorningHaze from "../../../assets/img/models/k4-hatchback/colors/k4-hatchback-color-morning-haze.webp";
import k4HatchbackColorAuroraBlackPearl from "../../../assets/img/models/k4-hatchback/colors/k4-hatchback-color-aurora-black-pearl.webp";
import k4HatchbackColorInterstellarGray from "../../../assets/img/models/k4-hatchback/colors/k4-hatchback-color-interstellar-gray.webp";
import k4HatchbackColorSteelGray from "../../../assets/img/models/k4-hatchback/colors/k4-hatchback-color-steel-gray.webp";
import k4HatchbackColorSnowWhitePearl from "../../../assets/img/models/k4-hatchback/colors/k4-hatchback-color-snow-white-pearl.webp";
// K4 Hatchback attributes image
import k4HatchbackAtributesMain from "../../../assets/img/models/k4-hatchback/atributes/k4-hatchback-atributes-main.webp";
// K4 Hatchback exterior images
import k4HatchbackExterior1 from "../../../assets/img/models/k4-hatchback/exterior/k4-hatchback-exterior-1.webp";
import k4HatchbackExterior2 from "../../../assets/img/models/k4-hatchback/exterior/k4-hatchback-exterior-2.webp";
import k4HatchbackExterior3 from "../../../assets/img/models/k4-hatchback/exterior/k4-hatchback-exterior-3.webp";
import k4HatchbackExterior4 from "../../../assets/img/models/k4-hatchback/exterior/k4-hatchback-exterior-4.webp";
import k4HatchbackExterior5 from "../../../assets/img/models/k4-hatchback/exterior/k4-hatchback-exterior-5.webp";
// K4 Hatchback interior images
import k4HatchbackInterior1 from "../../../assets/img/models/k4-hatchback/interior/k4-hatchback-interior-1.webp";
import k4HatchbackInterior2 from "../../../assets/img/models/k4-hatchback/interior/k4-hatchback-interior-2.webp";
import k4HatchbackInterior3 from "../../../assets/img/models/k4-hatchback/interior/k4-hatchback-interior-3.webp";
import k4HatchbackInterior4 from "../../../assets/img/models/k4-hatchback/interior/k4-hatchback-interior-4.webp";
import k4HatchbackInterior5 from "../../../assets/img/models/k4-hatchback/interior/k4-hatchback-interior-5.webp";
// K4 Hatchback carousel images (360 visualizer / dimensiones)
import k4HatchbackFront from "../../../assets/img/models/k4-hatchback/carousel/k4-hatchback-front.webp";
import k4HatchbackBack from "../../../assets/img/models/k4-hatchback/carousel/k4-hatchback-back.webp";
import k4HatchbackSide from "../../../assets/img/models/k4-hatchback/carousel/k4-hatchback-side.webp";
// K4 Hatchback documents
import k4HatchbackFichaTecnica from "../../../assets/fichas/Ficha técnica K4 Hatch Turbo.pdf";
import k4HatchbackFolleto from "../../../assets/fichas/folleto K4 Hatch Turbo.pdf";

export const k4HatchbackImages = {
  heroImage: { desktop: k4HatchbackHeroDesktop, mobile: k4HatchbackHeroMobile },
  attributes: { desktop: k4HatchbackAtributesMain, mobile: k4HatchbackAtributesMain },
  carousel: {
    front: { desktop: k4HatchbackFront, mobile: k4HatchbackFront },
    back: { desktop: k4HatchbackBack, mobile: k4HatchbackBack },
    side: { desktop: k4HatchbackSide, mobile: k4HatchbackSide },
  },
  colors: {
    fieryRed: k4HatchbackColorFieryRed,
    sparklingYellow: k4HatchbackColorSparklingYellow,
    morningHaze: k4HatchbackColorMorningHaze,
    auroraBlackPearl: k4HatchbackColorAuroraBlackPearl,
    interstellarGray: k4HatchbackColorInterstellarGray,
    steelGray: k4HatchbackColorSteelGray,
    snowWhitePearl: k4HatchbackColorSnowWhitePearl,
  },
  exterior: {
    image1: { desktop: k4HatchbackExterior1, mobile: k4HatchbackExterior1 },
    image2: { desktop: k4HatchbackExterior2, mobile: k4HatchbackExterior2 },
    image3: { desktop: k4HatchbackExterior3, mobile: k4HatchbackExterior3 },
    image4: { desktop: k4HatchbackExterior4, mobile: k4HatchbackExterior4 },
    image5: { desktop: k4HatchbackExterior5, mobile: k4HatchbackExterior5 },
  },
  interior: {
    image1: { desktop: k4HatchbackInterior1, mobile: k4HatchbackInterior1 },
    image2: { desktop: k4HatchbackInterior2, mobile: k4HatchbackInterior2 },
    image3: { desktop: k4HatchbackInterior3, mobile: k4HatchbackInterior3 },
    image4: { desktop: k4HatchbackInterior4, mobile: k4HatchbackInterior4 },
    image5: { desktop: k4HatchbackInterior5, mobile: k4HatchbackInterior5 },
  },
  fichas: k4HatchbackFichaTecnica,
  folleto: k4HatchbackFolleto,
};
